import api from './index';
//
let exports = {};

// 获取服务显示分类（tree）
exports.getServcDispCatList = function (postData, callback) {// 获取服务显示分类（Tree）
    api.post('/servcOper/disp/cat/list/get')
    .data(postData)
    .done(callback)
    .go();
};

//
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/servcOper.js
// module id = 4623
// module chunks = 0